import Vue from 'vue'
import App from './App.vue'
import { sync } from 'vuex-router-sync'
import store from './store'
import router from './router/index'
import 'reset.css'
import 'normalize.css'
import FastClick from 'fastclick'
Vue.config.productionTip = false

if ('addEventListener' in document && 'ontouchstart' in window) {
  FastClick.prototype.focus = function(targetElement) {
    targetElement.focus()
  }
  document.addEventListener(
    'DOMContentLoaded',
    function() {
      FastClick.attach(document.body)
    },
    false
  )
}
import API from '@/http/api'
Vue.prototype.$http = API

import { formatStrAmount, getCdnImgByStyle, formatHttpImg } from '@/utils/help'
Vue.prototype.formatStrAmount = formatStrAmount
Vue.prototype.getCdnImgByStyle = getCdnImgByStyle
Vue.prototype.formatHttpImg = formatHttpImg

sync(store, router)

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
